import React from 'react'
import { observer } from 'mobx-react'
import { Time as BaseTime } from '@morningtrain/react-fields'
import withTranslations from 'support/hoc/withTranslations'

function Time (props) {
  return <BaseTime {...props} withPortal={false} />
}

export default observer(withTranslations(Time))
